import { AfterViewInit, Component, HostListener, signal } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { AdminService } from '../services/admin.service'
import { MatCheckboxChange } from '@angular/material/checkbox'
import { EventService } from '../services/event.service'
import { LanguageService } from '../services/language.service'
import { ToastService } from '../services/toast.service'
import { LogService } from '../services/log.service'
import { GlobalDataService } from '../services/global-data.service'
import { scrollDetector } from '../utils/scroll-detector.util'
import { defaultHeaderMenuItems } from '../data/header-menu.data'
import { IPageConfig } from '../interfaces/config.interface'


@Component({
  template: ``,
  standalone: false,
})
export abstract class ConfigurablePageComponent implements AfterViewInit {
  pageConfig = signal<IPageConfig>({
    seo: {
      data: {
        title: '',
        description: ''
      }
    },
    components: {}
  })
  adminMode = false
  mobilePreviewWidth = 375
  isScrolling = false
  defaultHeaderMenuItems = defaultHeaderMenuItems

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected globalDataService: GlobalDataService,
    protected adminService: AdminService,
    protected eventService: EventService,
    protected languageService: LanguageService,
    protected toastService: ToastService,
    protected logger: LogService,
  ) {
    this.adminMode = adminService.isAdminEnabled()

    if (window.parent !== window) {
      window.addEventListener('message', (event) => {
        switch (event.data?.type) {
          case 'configUpdated':
            this.eventService.notifyConfigUpdated()
            break
          case 'clientUpdated':
            this.eventService.notifyClientUpdated()
            break
          case 'currenciesChanged':
            this.eventService.notifyCurrenciesChanged()
            break
          case 'languagesChanged':
            this.eventService.notifyLanguagesChanged()
            break
        }
      })
      activatedRoute.data.subscribe(({ module, asset }) => {
        window.parent.postMessage({ type: 'pageLoaded', module, asset }, '*')
      })
    }
  }

  ngAfterViewInit(): void {
    const msg = this.languageService.getRedirectMessage()
    if (msg) {
      this.languageService.clearRedirectMessage()
      this.toastService.error({ message: msg })
    }
  }

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    this.isScrolling = scrollDetector()
  }

  onMobilePreviewWidthChange(event: Event): void {
    const width = (event.target as HTMLInputElement).value
    this.adminService.mobilePreviewWidth.set(parseInt(width))
  }

  onToggleMobilePreviewMode(change: MatCheckboxChange) {
    this.adminService.mobilePreviewMode.set(change.checked)
  }
}
